import React from 'react';
import {
    Box,
    Paper,
    Typography,
    Stepper,
    Step,
    StepLabel,
} from '@mui/material';
import {
    Schedule as ScheduleIcon,
    Receipt as ReceiptIcon,
    AssignmentTurnedIn as AssignmentTurnedInIcon,
    Factory as FactoryIcon,
    Inventory as InventoryIcon,
    RequestQuote as RequestQuoteIcon,
    LocalShipping as LocalShippingIcon,
} from '@mui/icons-material';

const OrderTraceback = ({ order }) => {
    if (!order) return null;

    const steps = [
        {
            label: 'Pedido Creado',
            date: order.created_at,
            user: order.seller?.first_name || order.seller?.username || 'Vendedor',
            icon: <ReceiptIcon />,
            description: 'El pedido fue registrado por ventas.'
        },
        {
            label: 'Validado / Confirmado',
            date: order.validated_at,
            user: order.validated_by?.first_name || order.validated_by?.username || 'Supervisor',
            icon: <AssignmentTurnedInIcon />,
            description: 'La orden fue confirmada para producción.'
        },
        {
            label: 'En Elaboración',
            date: order.production_started_at,
            icon: <FactoryIcon />,
            description: 'El pedido ingresó a la línea de producción.'
        },
        {
            label: 'Listo para Facturar',
            date: order.production_finished_at,
            icon: <InventoryIcon />,
            description: 'Pesaje finalizado. Pedido esperando facturación.'
        },
        {
            label: 'Facturado',
            date: order.invoiced_at,
            icon: <RequestQuoteIcon />,
            description: 'Pedido facturado. Esperando retiro o reparto.'
        },
        {
            label: 'Entregado',
            date: order.delivered_at,
            icon: <LocalShippingIcon />,
            description: order.receiver_name ? `Retirado por: ${order.receiver_name}` : 'Pedido entregado al cliente.'
        }
    ].filter(step => step.date);

    if (steps.length === 0) return null;

    return (
        <Paper sx={{ p: 3, mb: 3, borderRadius: '0.75rem', border: '1px solid #d0dbe7', bgcolor: '#fff' }}>
            <Typography variant="subtitle1" sx={{ mb: 3, fontWeight: 700, color: '#0e141b', display: 'flex', alignItems: 'center', gap: 1 }}>
                <ScheduleIcon sx={{ fontSize: '1.2rem', color: '#1976d2' }} />
                Trazabilidad del Pedido (Full Traceback)
            </Typography>
            <Stepper orientation="vertical" sx={{
                '& .MuiStepConnector-line': { minHeight: '20px' }
            }}>
                {steps.map((step, index) => (
                    <Step key={index} active={true}>
                        <StepLabel
                            StepIconComponent={() => (
                                <Box sx={{
                                    bgcolor: index === steps.length - 1 ? '#1976d2' : '#e3f2fd',
                                    color: index === steps.length - 1 ? 'white' : '#1976d2',
                                    borderRadius: '50%',
                                    p: 0.8,
                                    display: 'flex',
                                    border: '1px solid #1976d2'
                                }}>
                                    {React.cloneElement(step.icon, { sx: { fontSize: '1.2rem' } })}
                                </Box>
                            )}
                        >
                            <Box sx={{ ml: 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                    <Typography sx={{ fontWeight: 700, fontSize: '0.9rem', color: '#0e141b' }}>{step.label}</Typography>
                                    <Typography sx={{ fontSize: '0.7rem', color: '#4e7397' }}>
                                        {new Date(step.date).toLocaleString('es-AR', { dateStyle: 'short', timeStyle: 'short' })}
                                        {step.user ? ` • ${step.user}` : ''}
                                    </Typography>
                                </Box>
                                <Typography sx={{ fontSize: '0.8rem', color: '#4e7397', mt: 0.2 }}>{step.description}</Typography>
                            </Box>
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Paper>
    );
};

export default OrderTraceback;
